// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import uploadToCloudinary from "../../utils/cloudinary";
// import {
//   RiAddLine,
//   RiEditLine,
//   RiDeleteBinLine,
//   RiArrowLeftSLine,
//   RiArrowRightSLine,
//   RiCloseLine,
// } from "react-icons/ri";
// import toast from "react-hot-toast";
// import Swal from "sweetalert2";
// import { confirmAndDelete } from "../../utils/confirmAndDelete";
// const FieldCardSkeleton = () => {
//   return (
//     <div className="relative rounded-2xl overflow-hidden shadow-lg animate-pulse">
//       {/* Background placeholder */}
//       <div className="w-full h-64 bg-gray-200" />

//       {/* Overlay placeholder */}
//       <div className="absolute inset-0 bg-black bg-opacity-20 flex flex-col justify-end p-4 rounded-2xl">
//         <div className="h-5 w-2/3 bg-gray-300 rounded mb-2"></div>
//         <div className="h-4 w-1/3 bg-gray-300 rounded"></div>
//       </div>
//     </div>
//   );
// };

// const AllFields = () => {
//   const [fields, setFields] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingField, setEditingField] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [formData, setFormData] = useState({
//     imageUrl: "",
//     fieldName: "",
//     price: "",
//     time: "",
//   });

//   const [errors, setErrors] = useState({}); // error messages

//   const fieldsPerPage = 6;
//   const totalPages = Math.ceil(fields.length / fieldsPerPage);
//   const indexOfLast = currentPage * fieldsPerPage;
//   const indexOfFirst = indexOfLast - fieldsPerPage;
//   const currentFields = fields.slice(indexOfFirst, indexOfLast);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const { data } = await axios.get(
//         `${process.env.REACT_APP_API_URL}/fields-rental/all-fields`
//       );
//       if (data?.rentals) {
//         setFields(data.rentals);
//       }
//     } catch (err) {
//       console.error(err);
//       // toast.error("Failed to fetch fields");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     setErrors({ ...errors, [name]: "" });
//   };

//   const openNewModal = () => {
//     setEditingField(null);
//     setFormData({ imageUrl: "", fieldName: "", price: "", time: "" });
//     setErrors({});
//     setIsModalOpen(true);
//   };

//   const openEditModal = (field) => {
//     setEditingField(field);
//     setFormData({
//       imageUrl: field.imageUrl,
//       fieldName: field.fieldName,
//       price: field.price,
//       time: field.time,
//     });
//     setErrors({});
//     setIsModalOpen(true);
//   };

//   // Delete field
//   const deleteField = async (_id) => {
//     const isConfirmed = await confirmAndDelete({
//       id: _id,
//       url: `${process.env.REACT_APP_API_URL}/fields-rental/delete-field`,
//     });

//     if (isConfirmed) {
//       try {
//         fetchData();

//         Swal.fire({
//           title: "Deleted!",
//           text: "Field has been removed successfully.",
//           icon: "success",
//           confirmButtonColor: "#10B981",
//           background: "#fff",
//         });
//       } catch (err) {
//         console.error("Error deleting field:", err);
//       }
//     }
//   };

//   // Upload a single image to Cloudinary
//   const handleFileUpload = async (file) => {
//     if (!file) return;
//     // Show loading toast
//     const toastId = toast.loading("Uploading image...");
//     try {
//       setUploading(true);
//       const uploadedUrl = await uploadToCloudinary(file);
//       setFormData({ ...formData, imageUrl: uploadedUrl });
//       setErrors({ ...errors, imageUrl: "" });
//       toast.success("Image uploaded successfully!", { id: toastId });
//     } catch (err) {
//       console.error("Cloudinary upload failed:", err);
//       toast.error("Image upload failed", { id: toastId });
//     } finally {
//       setUploading(false);
//     }
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     if (!formData.fieldName.trim())
//       newErrors.fieldName = "Field name is required";
//     if (!formData.imageUrl) newErrors.imageUrl = "Please upload an image";
//     if (!formData.price) newErrors.price = "Price is required";
//     if (!formData.time.trim()) newErrors.time = "Time is required";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     const newField = {
//       _id: editingField ? editingField._id : Date.now(),
//       ...formData,
//       price: Number(formData.price),
//     };
//     try {
//       setIsSubmitting(true);
//       if (editingField) {
//         await axios.put(
//           `${process.env.REACT_APP_API_URL}/fields-rental/edit-field/${editingField._id}`,
//           newField
//         );
//         toast.success("Field updated successfully");
//       } else {
//         await axios.post(
//           `${process.env.REACT_APP_API_URL}/fields-rental/add-field-rental`,
//           newField
//         );
//         toast.success("Field added successfully");
//       }
//       fetchData();
//       setIsModalOpen(false);
//     } catch (error) {
//       console.log("Error Adding / Updating field", error);
//       toast.error("Something went wrong while saving");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-transparent p-6">
//       {/* Header */}
//       <div className="flex justify-between items-center mb-8">
//         <h1 className="text-3xl font-heading font-bold bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent">
//           All Fields
//         </h1>
//         <button
//           onClick={openNewModal}
//           className="bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white py-2 px-4 rounded-xl flex items-center shadow-lg hover:shadow-xl transition-shadow"
//         >
//           <RiAddLine className="mr-2" />
//           New Field
//         </button>
//       </div>

//       {/* Field Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
//         {loading
//           ? Array.from({ length: fieldsPerPage }).map((_, idx) => (
//               <FieldCardSkeleton key={idx} />
//             ))
//           : currentFields.map((field) => (
//               <div
//                 key={field._id}
//                 className="relative rounded-2xl overflow-hidden shadow-lg cursor-pointer transform hover:scale-[1.02] transition-transform"
//               >
//                 {/* Background Image */}
//                 <div
//                   className="w-full h-64 bg-center bg-cover"
//                   style={{ backgroundImage: `url(${field.imageUrl})` }}
//                 />

//                 {/* Overlay */}
//                 <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end p-4 rounded-2xl">
//                   <h2 className="text-xl font-bold text-white font-heading mb-1">
//                     {field.fieldName}
//                   </h2>
//                   <p className="text-white">
//                     <span className="font-semibold">{field.price}</span> /{" "}
//                     {field.time}
//                   </p>

//                   {/* Edit/Delete Icons */}
//                   <div className="absolute top-3 right-3 flex space-x-2">
//                     <button
//                       onClick={() => openEditModal(field)}
//                       className="bg-white bg-opacity-80 p-2 rounded-lg text-primaryBtnHoverColor hover:bg-primaryBtnColor hover:text-white transition-colors"
//                     >
//                       <RiEditLine />
//                     </button>
//                     <button
//                       onClick={() => deleteField(field._id)}
//                       className="bg-white bg-opacity-80 p-2 rounded-lg text-red-500 hover:bg-red-500 hover:text-white transition-colors"
//                     >
//                       <RiDeleteBinLine />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-center items-center space-x-4">
//           <button
//             onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
//             disabled={currentPage === 1}
//             className={`p-2 rounded-lg ${
//               currentPage === 1
//                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                 : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
//             }`}
//           >
//             <RiArrowLeftSLine size={20} />
//           </button>

//           {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPage(page)}
//               className={`px-3 py-1 rounded-lg ${
//                 currentPage === page
//                   ? "bg-primaryBtnColor text-white"
//                   : "bg-gray-200 text-secondaryTextColor hover:bg-gray-300"
//               }`}
//             >
//               {page}
//             </button>
//           ))}

//           <button
//             onClick={() =>
//               currentPage < totalPages && setCurrentPage(currentPage + 1)
//             }
//             disabled={currentPage === totalPages}
//             className={`p-2 rounded-lg ${
//               currentPage === totalPages
//                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                 : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
//             }`}
//           >
//             <RiArrowRightSLine size={20} />
//           </button>
//         </div>
//       )}
//       {/* Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-2xl w-full max-w-lg border border-primaryTextColor shadow-xl">
//             <div className="flex justify-between items-center p-4 border-b border-gray-200">
//               <h2 className="text-xl font-bold text-primaryTextColor">
//                 {editingField ? "Edit Field" : "Add New Field"}
//               </h2>
//               <button
//                 onClick={() => setIsModalOpen(false)}
//                 className="text-gray-500 hover:text-primaryBtnHoverColor"
//               >
//                 <RiCloseLine size={24} />
//               </button>
//             </div>

//             <form onSubmit={handleSubmit} className="p-6 space-y-4">
//               {/* Field Name */}
//               <div>
//                 <label className="block text-sm text-secondaryTextColor mb-2">
//                   Field Name
//                 </label>
//                 <input
//                   type="text"
//                   name="fieldName"
//                   value={formData.fieldName}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 />
//                 {errors.fieldName && (
//                   <p className="text-red-500 text-sm mt-1">
//                     {errors.fieldName}
//                   </p>
//                 )}
//               </div>

//               {/* Image upload (only one) */}
//               <label className="block text-sm text-secondaryTextColor mb-2">
//                 Image
//               </label>
//               <div>
//                 {formData?.imageUrl && (
//                   <>
//                     {/* Preview + spinner */}
//                     <div className="relative w-32 h-32 mb-2">
//                       {formData.imageUrl && (
//                         <img
//                           src={formData.imageUrl}
//                           alt="preview"
//                           className="w-32 h-32 object-cover rounded-lg"
//                         />
//                       )}
//                     </div>
//                   </>
//                 )}

//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) => handleFileUpload(e.target.files[0])}
//                   className="w-full border border-gray-300 rounded-lg p-2 text-primaryTextColor"
//                 />
//                 {errors.imageUrl && (
//                   <p className="text-red-500 text-sm mt-1">{errors.imageUrl}</p>
//                 )}
//               </div>

//               {/* Price */}
//               <div>
//                 <label className="block text-sm text-secondaryTextColor mb-2">
//                   Price
//                 </label>
//                 <input
//                   type="number"
//                   name="price"
//                   value={formData.price}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 />
//                 {errors.price && (
//                   <p className="text-red-500 text-sm mt-1">{errors.price}</p>
//                 )}
//               </div>

//               {/* Time */}
//               <div>
//                 <label className="block text-sm text-secondaryTextColor mb-2">
//                   Time (e.g. per hour, per day)
//                 </label>
//                 <input
//                   type="text"
//                   name="time"
//                   value={formData.time}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 />
//                 {errors.time && (
//                   <p className="text-red-500 text-sm mt-1">{errors.time}</p>
//                 )}
//               </div>

//               {/* Actions */}
//               <div className="flex justify-end space-x-3">
//                 <button
//                   type="button"
//                   onClick={() => setIsModalOpen(false)}
//                   className="bg-gray-200 text-secondaryTextColor py-2 px-4 rounded-lg hover:bg-gray-300"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   disabled={uploading || isSubmitting}
//                   type="submit"
//                   className="bg-primaryBtnColor text-white w-36 flex items-center justify-center py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor"
//                 >
//                   {isSubmitting ? (
//                     <div class="spinner w-full"></div>
//                   ) : editingField ? (
//                     "Update Field"
//                   ) : (
//                     "Add Field"
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AllFields;

import axios from "axios";
import React, { useEffect, useState } from "react";
import uploadToCloudinary from "../../utils/cloudinary";
import {
  RiAddLine,
  RiEditLine,
  RiDeleteBinLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiCloseLine,
} from "react-icons/ri";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { confirmAndDelete } from "../../utils/confirmAndDelete";

const FieldCardSkeleton = () => {
  return (
    <div className="relative rounded-2xl overflow-hidden shadow-lg animate-pulse">
      {/* Background placeholder */}
      <div className="w-full h-64 bg-gray-200" />

      {/* Overlay placeholder */}
      <div className="absolute inset-0 bg-black bg-opacity-20 flex flex-col justify-end p-4 rounded-2xl">
        <div className="h-5 w-2/3 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 w-1/3 bg-gray-300 rounded"></div>
      </div>
    </div>
  );
};

const AllFields = () => {
  const [fields, setFields] = useState([]);
  const [sportsCategories, setSportsCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(false);

  const [formData, setFormData] = useState({
    imageUrl: "",
    fieldName: "",
    price: "",
    time: "",
    sportsCategory: "",
  });

  const [errors, setErrors] = useState({});

  const fieldsPerPage = 6;
  const totalPages = Math.ceil(fields.length / fieldsPerPage);
  const indexOfLast = currentPage * fieldsPerPage;
  const indexOfFirst = indexOfLast - fieldsPerPage;
  const currentFields = fields.slice(indexOfFirst, indexOfLast);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/fields-rental/all-fields`
      );
      if (data?.rentals) {
        setFields(data.rentals);
      }
    } catch (err) {
      console.error(err);
      // toast.error("Failed to fetch fields");
    } finally {
      setLoading(false);
    }
  };

  const fetchSportsCategories = async () => {
    try {
      setCategoriesLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/sports-categories/all-categories`
      );
      if (data?.categories) {
        setSportsCategories(data.categories);
      }
    } catch (err) {
      console.error("Failed to fetch sports categories:", err);
      toast.error("Failed to load sports categories");
    } finally {
      setCategoriesLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchSportsCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const openNewModal = () => {
    setEditingField(null);
    setFormData({
      imageUrl: "",
      fieldName: "",
      price: "",
      time: "",
      sportsCategory: "",
    });
    setErrors({});
    setIsModalOpen(true);
  };

  const openEditModal = (field) => {
    setEditingField(field);
    setFormData({
      imageUrl: field.imageUrl,
      fieldName: field.fieldName,
      price: field.price,
      time: field.time,
      // Handle both populated object and ID string
      sportsCategory: field?.sportsCategory?._id || field?.sportsCategory || "",
    });
    setErrors({});
    setIsModalOpen(true);
  };

  // Delete field
  const deleteField = async (_id) => {
    const isConfirmed = await confirmAndDelete({
      id: _id,
      url: `${process.env.REACT_APP_API_URL}/fields-rental/delete-field`,
    });

    if (isConfirmed) {
      try {
        fetchData();

        Swal.fire({
          title: "Deleted!",
          text: "Field has been removed successfully.",
          icon: "success",
          confirmButtonColor: "#10B981",
          background: "#fff",
        });
      } catch (err) {
        console.error("Error deleting field:", err);
      }
    }
  };

  // Upload a single image to Cloudinary
  const handleFileUpload = async (file) => {
    if (!file) return;
    // Show loading toast
    const toastId = toast.loading("Uploading image...");
    try {
      setUploading(true);
      const uploadedUrl = await uploadToCloudinary(file);
      setFormData({ ...formData, imageUrl: uploadedUrl });
      setErrors({ ...errors, imageUrl: "" });
      toast.success("Image uploaded successfully!", { id: toastId });
    } catch (err) {
      console.error("Cloudinary upload failed:", err);
      toast.error("Image upload failed", { id: toastId });
    } finally {
      setUploading(false);
    }
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.fieldName.trim())
      newErrors.fieldName = "Field name is required";
    if (!formData.imageUrl) newErrors.imageUrl = "Please upload an image";
    if (!formData.price) newErrors.price = "Price is required";
    if (!formData.time.trim()) newErrors.time = "Time is required";
    if (!formData?.sportsCategory)
      newErrors.sportsCategory = "Sports category is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const newField = {
      _id: editingField ? editingField._id : Date.now(),
      ...formData,
      price: Number(formData.price),
    };
    try {
      setIsSubmitting(true);
      if (editingField) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/fields-rental/edit-field/${editingField._id}`,
          newField
        );
        toast.success("Field updated successfully");
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/fields-rental/add-field-rental`,
          newField
        );
        toast.success("Field added successfully");
      }
      fetchData();
      setIsModalOpen(false);
    } catch (error) {
      console.log("Error Adding / Updating field", error);
      toast.error("Something went wrong while saving");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Helper function to get sports category name by ID
  const getSportsCategoryName = (categoryData) => {
    // If categoryData is an object (populated), return the name directly
    if (typeof categoryData === "object" && categoryData?.name) {
      return categoryData.name;
    }
    // If categoryData is a string (ID), find the category in our local state
    if (typeof categoryData === "string") {
      const category = sportsCategories.find((cat) => cat._id === categoryData);
      return category ? category.name : "Unknown Category";
    }
    return "No Category";
  };

  return (
    <div className="min-h-screen bg-transparent p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-heading font-bold bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent">
          All Fields
        </h1>
        <button
          onClick={openNewModal}
          className="bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white py-2 px-4 rounded-xl flex items-center shadow-lg hover:shadow-xl transition-shadow"
        >
          <RiAddLine className="mr-2" />
          New Field
        </button>
      </div>

      {/* Field Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
        {loading
          ? Array.from({ length: fieldsPerPage }).map((_, idx) => (
              <FieldCardSkeleton key={idx} />
            ))
          : currentFields.map((field) => (
              <div
                key={field._id}
                className="relative rounded-2xl overflow-hidden shadow-lg cursor-pointer transform hover:scale-[1.02] transition-transform"
              >
                {/* Background Image */}
                <div
                  className="w-full h-64 bg-center bg-cover"
                  style={{ backgroundImage: `url(${field.imageUrl})` }}
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col justify-end p-4 rounded-2xl">
                  <h2 className="text-xl font-bold text-white font-heading mb-1">
                    {field.fieldName}
                  </h2>
                  <p className="text-white mb-1">
                    <span className="font-semibold">{field.price}</span> {" "}
                    {field.time}
                  </p>
                  {field.sportsCategory && (
                    <p className="text-white text-sm opacity-90">
                      Sports: {getSportsCategoryName(field?.sportsCategory)}
                    </p>
                  )}

                  {/* Edit/Delete Icons */}
                  <div className="absolute top-3 right-3 flex space-x-2">
                    <button
                      onClick={() => openEditModal(field)}
                      className="bg-white bg-opacity-80 p-2 rounded-lg text-primaryBtnHoverColor hover:bg-primaryBtnColor hover:text-white transition-colors"
                    >
                      <RiEditLine />
                    </button>
                    <button
                      onClick={() => deleteField(field._id)}
                      className="bg-white bg-opacity-80 p-2 rounded-lg text-red-500 hover:bg-red-500 hover:text-white transition-colors"
                    >
                      <RiDeleteBinLine />
                    </button>
                  </div>
                </div>
              </div>
            ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center space-x-4">
          <button
            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
            className={`p-2 rounded-lg ${
              currentPage === 1
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
            }`}
          >
            <RiArrowLeftSLine size={20} />
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              className={`px-3 py-1 rounded-lg ${
                currentPage === page
                  ? "bg-primaryBtnColor text-white"
                  : "bg-gray-200 text-secondaryTextColor hover:bg-gray-300"
              }`}
            >
              {page}
            </button>
          ))}

          <button
            onClick={() =>
              currentPage < totalPages && setCurrentPage(currentPage + 1)
            }
            disabled={currentPage === totalPages}
            className={`p-2 rounded-lg ${
              currentPage === totalPages
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
            }`}
          >
            <RiArrowRightSLine size={20} />
          </button>
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-lg border border-primaryTextColor shadow-xl">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h2 className="text-xl font-bold text-primaryTextColor">
                {editingField ? "Edit Field" : "Add New Field"}
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-primaryBtnHoverColor"
              >
                <RiCloseLine size={24} />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              {/* Field Name */}
              <div>
                <label className="block text-sm text-secondaryTextColor mb-2">
                  Field Name
                </label>
                <input
                  type="text"
                  name="fieldName"
                  value={formData.fieldName}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
                {errors.fieldName && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.fieldName}
                  </p>
                )}
              </div>

              {/* Sports Category Dropdown */}
              <div>
                <label className="block text-sm text-secondaryTextColor mb-2">
                  Sports Category
                </label>
                <select
                  name="sportsCategory"
                  value={formData?.sportsCategory}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                  disabled={categoriesLoading}
                >
                  <option value="">
                    {categoriesLoading
                      ? "Loading categories..."
                      : "Select a sports category"}
                  </option>
                  {sportsCategories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
                {errors?.sportsCategory && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors?.sportsCategory}
                  </p>
                )}
              </div>

              {/* Image upload (only one) */}
              <label className="block text-sm text-secondaryTextColor mb-2">
                Image
              </label>
              <div>
                {formData?.imageUrl && (
                  <>
                    {/* Preview + spinner */}
                    <div className="relative w-32 h-32 mb-2">
                      {formData.imageUrl && (
                        <img
                          src={formData.imageUrl}
                          alt="preview"
                          className="w-32 h-32 object-cover rounded-lg"
                        />
                      )}
                    </div>
                  </>
                )}

                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileUpload(e.target.files[0])}
                  className="w-full border border-gray-300 rounded-lg p-2 text-primaryTextColor"
                />
                {errors.imageUrl && (
                  <p className="text-red-500 text-sm mt-1">{errors.imageUrl}</p>
                )}
              </div>

              {/* Price */}
              <div>
                <label className="block text-sm text-secondaryTextColor mb-2">
                  Price
                </label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
                {errors.price && (
                  <p className="text-red-500 text-sm mt-1">{errors.price}</p>
                )}
              </div>

              {/* Time */}
              <div>
                <label className="block text-sm text-secondaryTextColor mb-2">
                  Time (e.g. per hour, per day)
                </label>
                <input
                  type="text"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
                {errors.time && (
                  <p className="text-red-500 text-sm mt-1">{errors.time}</p>
                )}
              </div>

              {/* Actions */}
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="bg-gray-200 text-secondaryTextColor py-2 px-4 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  disabled={uploading || isSubmitting}
                  type="submit"
                  className="bg-primaryBtnColor text-white w-36 flex items-center justify-center py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor"
                >
                  {isSubmitting ? (
                    <div class="spinner w-full"></div>
                  ) : editingField ? (
                    "Update Field"
                  ) : (
                    "Add Field"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllFields;
